import { theme as antdTheme } from 'antd';

export const THEME = Object.freeze({
  LIGHT: 'light',
  DARK: 'dark'
});
export const PRODUCT_TYPE = Object.freeze({
  GAME: 'GAME',
  SERVICE: 'SERVICE'
});

const commonTokens = Object.freeze({
  colorError: '#ff000d',
  borderRadius: 6
});

export const light_theme = Object.freeze({
  token: {
    ...commonTokens,
    colorTextBase: '#000',
    colorText: 'rgba(0, 0, 0, 0.88)',
    colorBorderSecondary: 'rgba(0, 0, 0, 0.15)',
    colorListItem: '#e7e7e7',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#ffffff',
    colorPrimary: '#FAD732'
  },
  algorithm: antdTheme.defaultAlgorithm
});

export const dark_theme = Object.freeze({
  token: {
    ...commonTokens,
    colorTextBase: '#fff',
    colorText: '#fff',
    colorListItem: 'rgb(39,39,39)',
    colorBorder: '#464646',
    colorBgContainer: '#313131',
    colorBgLayout: '#1f1f1f',
    colorBorderSecondary: 'rgba(255, 255, 255, 0.15)',
    wireframe: false,
    colorTextQuaternary: 'rgba(255, 255, 255, 0.45)'
  },
  algorithm: antdTheme.darkAlgorithm
});
